import { OffPlanFilterApi } from "./../../api/plan/off_plan/filter";
import { OffPlanApi } from "./../../api/plan/off_plan/index";
import { plainToClassFromExist } from "class-transformer";
import { ResponseModel } from "@/models/classes/response";
import { ResponsesModel } from "@/models/classes/responses";
import { OffPlanFilterModel } from "@/models/classes/plan/off_plan/filter";
import { OffPlanCustomerModel } from "@/models/classes/plan/off_plan/customer";
import { VerifyOffPlanModel } from "@/models/classes/plan/off_plan";

const apiFilter = new OffPlanFilterApi();
const api = new OffPlanApi();

export class OffPlanService {
  fetchFilter = async (params: any = {}, signal?: AbortSignal) => {
    const resData = await apiFilter.getFilter(params, signal);
    const resModel = plainToClassFromExist(
      new ResponsesModel<OffPlanFilterModel>(OffPlanFilterModel),
      resData
    );
    if (resModel.status == 200 && typeof resModel.data == "object") {
      return { data: resModel.data, total: resModel.total ?? 0 };
    }
    return undefined;
  };

  fetchCustomerOffPlan = async (params: any = {}, signal?: AbortSignal) => {
    const resData = await apiFilter.getCustomerOffPlan(params, signal);
    const resModel = plainToClassFromExist(
      new ResponsesModel<OffPlanCustomerModel>(OffPlanCustomerModel),
      resData
    );
    if (resModel.status == 200 && typeof resModel.data == "object") {
      return { data: resModel.data, total: resModel.total ?? 0 };
    }
  };

  fetchVerifyOffPlan = async (params: any = {}, signal?: AbortSignal) => {
    const resData = await api.verifyOffPlan(params, signal);

    const resModel = plainToClassFromExist(
      new ResponseModel<VerifyOffPlanModel>(VerifyOffPlanModel),
      resData
    );

    if (resModel.status == 200 && typeof resModel.data == "object") {
      return resModel.data;
    }
    return undefined;
  };
}
